export default "__VITE_ASSET__DmPAap5h__"